// @flow

import type {ApplicationState} from '../../types'
import type {SessionState} from '../types'

export function isLoading(appState: ApplicationState): boolean {
  return _isLoading(appState.session)
}

function _isLoading(state: SessionState): boolean{
  return state.isLoading
}

isLoading.internal = _isLoading
